import React from "react";
import { Grid, TextField } from "@mui/material";

function AdditionalDetails({ formData, setFormData, inputErrors, size, borderRadius }) {
	return (
		<Grid container spacing={2}>
			<Grid item xs={12} sm={6} style={{ justifyContent: "flex-start" }}>
				<TextField
					// value={formData?.firstName}
					size={size}
					id="special-instruction"
					fullWidth
					multiline
					rows={4}
					label='Special Instructions from the shadchan, for example: “If you send me an email, please put your name in the subject line"'
					variant="outlined"
					// error={inputErrors?.title}
					onChange={(e) =>
						setFormData({ ...formData, instructions: e?.target?.value })
					}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
			<Grid item xs={12} sm={6}>
				<TextField
					value={formData?.aboutMe}
					size={size}
					id="about_me"
					fullWidth
					multiline
					rows={4}
					label="About me, tell a bit about yourself"
					variant="outlined"
					error={inputErrors?.aboutMe}
					onChange={(e) => setFormData({ ...formData, aboutMe: e?.target?.value })}
					InputProps={{ sx: { borderRadius: borderRadius } }}
				/>
			</Grid>
		</Grid>
	);
}

export default AdditionalDetails;
